import { makeStyles } from "@material-ui/core";
import { FaAsterisk } from "react-icons/fa";

import { COLORS } from "../../theme/colors";

const useStyles = makeStyles((theme) => ({
  asterisk: {
    color: COLORS.red,
    padding: theme.spacing(0.5),
  },
}));

export const RedAsterisk = () => {
  const classes = useStyles();

  return <FaAsterisk className={classes.asterisk} size={7} />;
};
